import React from "react";
import CustomTable from "../../components/CustomTable";
import { get } from "../../../store/actions/CommonActions";
import { GET_INITIATIVE } from "../../../store/actions/InitiativeTypes";
import { getInitiatives } from "../../../services/CommonServices";

const Initiative = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage = 1, pageSize = 10) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Edition",
      key: "title",
      render: (row) => <span>{`${row.title} - ${row.edition}`}</span>,
    },
    {
      label: "Duration",
      render: (row) => {
        const startDate = new Date(row.start_date);
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        let startMonth = (startDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
        let startDay = startDate.getDate().toString().padStart(2, "0");
        let startYear = startDate.getFullYear();
        const endDate = new Date(row.end_date);
        let endMonth = (endDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
        let endDay = endDate.getDate().toString().padStart(2, "0");
        let endYear = endDate.getFullYear();
        return (
          <span>{`${startDay} ${monthNames[startDate.getMonth()]} - ${endDay} ${monthNames[endDate.getMonth()]
            } (${startYear == endYear
              ? startYear
              : startYear.toString() + "-" + endYear.toString()
            })`}</span>
        );
      },
    },
    {
      label: "City",
      // key: "city",
      render: (row, index) => <span>{row?.city?.name}</span>,
      // subKey: 'name'
    },
    {
      label: "Curator",
      // key: "curator",
      render: (row, index) =>
        row?.curator ? (<span>{`${row?.curator?.firstname} ${row?.curator?.lastname}`}</span>) : "-",
      // subKey: 'name'
    },
  ];
  return (
    <CustomTable
      title="Initiatives"
      addBtnTitle="Create New Initiative"
      columns={columns}
      getHook={getInitiatives}
      store={"initiative"}
      deleteHook={"initiative"}
    />
  );
};

export default Initiative;
